export const erc20TokenAddressByNetwork = {
    'goerli-alpha': '0x07394cbe418daa16e42b87ba67372d4ab4a5df0b05c6e554d158458ce245bc10',
    'mainnet-alpha': '0x06a09ccb1caaecf3d9683efe335a667b2169a409d19c589ba1eb771cd210af75',
    'sepolia-alpha': ''
}

export type PublicNetwork = 'goerli-alpha' | 'mainnet-alpha' | 'sepolia-alpha'
export type Network = PublicNetwork | 'localhost'

export enum StarknetChainId {
    // eslint-disable-next-line no-unused-vars
    MAINNET = '0x534e5f4d41494e',
    // eslint-disable-next-line no-unused-vars
    TESTNET = '0x534e5f474f45524c49',
    SEPOLIA_TESTNET = '0x534e5f5345504f4c4941'
}
